import { ButtonHTMLAttributes, forwardRef, ReactElement } from 'react'
import { Slot, Slottable } from '@radix-ui/react-slot'
import { cva, VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const buttonVariants = cva(
  [
    'group/button relative ',
    'flex space-x-spacing-sm items-center justify-center'
  ],
  {
    variants: {
      variant: {
        link: 'p-0 justify-start rounded-none',
        primary:
          'rounded-radius-minimal py-spacing-xs px-spacing-xs bg-black-light text-text-button-primary-light dark:bg-surface-primay-invert-light dark:text-text-button-primary-dark',
        secondary:
          'rounded-radius-minimal py-spacing-xs px-spacing-xs bg-transparent border border-border-secondary-light text-text-button-secondary-light dark:border-border-secondary-dark dark:text-text-button-secondary-dark [.light_&]:bg-transparent [.light_&]:border-border-secondary-light [.light_&]:text-text-button-secondary-light',
        tertiary:
          'rounded-radius-minimal py-spacing-xs px-spacing-xs bg-black-light text-text-button-primary-light'
      }
    },
    defaultVariants: {
      variant: 'primary'
    }
  }
)

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean
    endIcon?: ReactElement | null
  }

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { children, variant, endIcon, className, asChild = false, ...props },
    ref
  ) => {
    const Component = asChild ? Slot : 'button'

    return (
      <Component
        ref={ref}
        className={cn(buttonVariants({ variant, className }), '')}
        {...props}
      >
        <Slottable>{children}</Slottable>
        {endIcon}
      </Component>
    )
  }
)

export default Button
